<template>
  <login-panel back-route-name="retrieve-options" class="temporary-password-sent" xs>
    <div class="temporary-password-sent__content">
      <div class="temporary-password-sent__icon">
        <img src="/static/imgs/send-email-green.png" alt="">
      </div>
      <h3 class="temporary-password-sent__title">
        {{ $t('login.temporary-password-sent') }}
      </h3>
      <p
        class="temporary-password-sent__description"
        v-html="$t('login.temporary-password-sent-text', { email })"
      >
      </p>
      <router-link
        class="btn btn-primary btn-block temporary-password-sent__go-to-login"
        :to="{ name: 'sign-in' }"
      >
        {{ $t('login.go-to-login-page') }}
      </router-link>
    </div>
  </login-panel>
</template>

<script>
import { mapGetters } from 'vuex';
import LoginPanel from '@/components/LoginPanel';

export default {
  components: {
    LoginPanel,
  },
  computed: {
    ...mapGetters([
      'recoverData',
    ]),
    email() {
      return this.recoverData ? this.recoverData.email : '';
    },
  },
  created() {
    if (!this.recoverData) {
      this.$router.push({
        name: 'insert-user-data',
      });
    }
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/mobile-first"

.temporary-password-sent
  &__content
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
  &__title
    font-weight: 600
    font-size: 1.1rem
    margin-top: 30px
    text-transform: uppercase
    text-align: center
  &__description
    text-align: center
    font-size: .9rem
    margin-top: 20px
  &__go-to-login
    font-weight: 600
    margin-top: 15px
  +media-min-sm()
  +media-min-md()
    &__icon
      margin-top: 60px
  +media-min-lg()
</style>
